<template>
    <div>
        <div v-if="legalForm === 'SCI'">
            <!-- <v-tabs v-model="companyUser.investment.partnerType" fixed-tabs style="
                    background-color: transparent !important;
                    border-bottom: 0.5px solid rgb(146, 146, 146) !important;
                    overflow: hidden;
                ">
                <v-tab value="landTenureAssociate" href="#landTenureAssociate">
                    <strong>Régime Foncier</strong></v-tab>
                <v-tab value="professionalRegimeAssociate" href="#professionalRegimeAssociate"
                    :disabled="user.type === 'NATURAL_PERSON'">
                    <strong>Régime Professionel</strong></v-tab>
            </v-tabs> -->
            <v-radio-group v-model="companyUser.investment.partnerType" inline class="pl-2">
                <v-radio value="landTenureAssociate" label="Régime Foncier (IR)" color="primary" />
                <v-radio
                    value="professionalRegimeAssociate"
                    label="Régime Professionel (IS)"
                    :disabled="user.type === 'NATURAL_PERSON'"
                    color="primary"
                />
            </v-radio-group>
            <v-tabs-window v-model="companyUser.investment.partnerType">
                <v-window-item value="landTenureAssociate">
                    <v-row no-gutters class="pt-2">
                        <v-col cols="12">
                            <h4>Identification</h4>
                        </v-col>
                        <template v-if="type === 'NATURAL_PERSON'">
                            <v-row no-gutters class="py-2">
                                <v-col cols="4">
                                    <v-text-field-filled
                                        v-model="companyUser.investment.taxNumber"
                                        :label="
                                            selectedCompany.taxSystemType === 'IR'
                                                ? 'Numéro fiscal'
                                                : 'Numéro fiscal (facultatif pour une SCI à l\'IS)'
                                        "
                                        outlined
                                        hide-details
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </template>

                        <template v-else-if="type === 'LEGAL_PERSON'">
                            <v-row no-gutters class="py-2">
                                <v-col cols="4">
                                    <v-text-field-filled
                                        v-model="companyUser.investment.siren"
                                        label="SIREN"
                                        outlined
                                        hide-details
                                        :rules="[
                                            (v) => !!v || $t('settings.itemRequired'),
                                            (v) => (v || '').length <= 9 || $t('settings.tooLong'),
                                            (v) => (v || '').length >= 9 || $t('settings.tooShort'),
                                        ]"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </template>
                    </v-row>
                </v-window-item>
                <v-window-item value="professionalRegimeAssociate">
                    <v-row no-gutters class="pt-2">
                        <v-col cols="12">
                            <h4>Identification</h4>
                        </v-col>
                        <v-row no-gutters class="py-2">
                            <v-col cols="4" class="pr-1">
                                <v-text-field-filled
                                    v-model="companyUser.investment.siren"
                                    label="SIREN"
                                    outlined
                                    hide-details
                                    :rules="[
                                        (v) => !!v || $t('settings.itemRequired'),
                                        (v) => (v || '').length <= 9 || $t('settings.tooLong'),
                                        (v) => (v || '').length >= 9 || $t('settings.tooShort'),
                                    ]"
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="4" class="pl-1">
                                <v-select-filled
                                    class="pr-1"
                                    hide-details
                                    outlined
                                    v-model="companyUser.investment.taxCategory"
                                    :items="['BIC', 'IS', 'BA']"
                                    label="Catégorie fiscale"
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="4" class="pl-1">
                                <v-checkbox
                                    v-model="companyUser.investment.holding"
                                    label="Holding"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="pt-1 pb-3">
                        <v-col cols="12">
                            <h4>Cadres (facultatif)</h4>
                        </v-col>
                        <v-row no-gutters class="py-2">
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="companyUser.investment.director.show"
                                    label="Administrateur"
                                    dense
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="companyUser.investment.accountant.show"
                                    label="Comptable"
                                    dense
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox
                                    v-model="companyUser.investment.manager.show"
                                    label="Gérant"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <template v-for="role in roles">
                            <v-row
                                no-gutters
                                class="py-2"
                                v-if="companyUser.investment[role.value].show"
                            >
                                <v-col cols="12">{{ role.name }}</v-col>
                                <v-col
                                    v-for="field in roleFields"
                                    :cols="field.value === 'address' ? 8 : 4"
                                    :class="field.class"
                                    :key="field.value"
                                >
                                    <v-text-field-filled
                                        v-model="companyUser.investment[role.value][field.value]"
                                        :label="field.name"
                                        outlined
                                        hide-details
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-divider v-if="companyUser.investment[role.value].show" />
                        </template>
                    </v-row>
                </v-window-item>
                <!-- <v-window-item key="shareTransfer" value="shareTransfer">
                    <v-row no-gutters class="pt-4">
                        <v-col cols="12">
                            <h4>Identification</h4>
                        </v-col>
                        <v-row no-gutters class="py-2">
                            <v-col cols="4" class="pr-1">
                                <v-text-field v-model="companyUser.investment.siren" label="SIREN" class="oss-"
                                    outlined dense hide-details :rules="[
            (v) => !!v || $t('settings.itemRequired'),
            (v) => (v || '').length <= 9 || $t('settings.tooLong'),
            (v) => (v || '').length >= 9 || $t('settings.tooShort'),
        ]"></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-1">
                                <oss-text-field v-model="companyUser.investment.buildingNumber"
                                    label="Numéro de l'immeuble" class="oss-" type="number" outlined dense
                                    hide-details></oss-text-field>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-window-item> -->
            </v-tabs-window>

            <v-divider />
            <!-- <v-col>
                <v-row no-gutters class >
                    <v-col cols="12" class="py-4 pb-2">
                        <h4>Investissement global</h4>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div>Total des parts</div>
                            <div>{{ calculateTotalShares() }}</div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div>Montant investit</div>
                            <div>{{ calculateTotalShareAmount() }} €</div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div>Total investit : </div>
                            <div>{{ calculateTotalInvest() }} €</div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div> Total pourcentage de détention </div>
                            <div>{{ calculateTotalpercentage() }} % </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div>Total des titres en nue-propriété </div>
                            <div>{{ calculateTotalbareOwnershipShares() }} </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <div class="text-center">
                            <div>Total des titres détenus en usufruit </div>
                            <div>{{ calculateTotalusufructShares() }} </div>
                        </div>
                    </v-col>


                </v-row>
            </v-col> -->

            <template v-if="companyUser.investment.partnerType !== 'shareTransfer'">
                <!-- <v-divider></v-divider> -->
                <!-- <v-row no-gutters class="pt-2">
                    <v-col cols="12">
                    <h4>Intégration dans la SCI</h4>
                    </v-col>
                    <v-row no-gutters class="py-2">
                        <v-col cols="6" class="pr-1">
                            <oss-date-picker-filled
                                label="Date d'entrée"
                                v-model="companyUser.investment.entryDate"
                                outlined
                                :textFieldReadOnly="false"
                                :text-field-readonly="false"
                                hide-details="auto"
                            ></oss-date-picker-filled>
                        </v-col>
                        <v-col cols="6" class="pr-1">
                            <oss-date-picker-filled
                                label="Date de sortie"
                                v-model="companyUser.investment.exitDate"
                                outlined
                                :textFieldReadOnly="false"
                                :text-field-readonly="false"
                                hide-details="auto"
                            ></oss-date-picker-filled>
                        </v-col>
                    </v-row>
                    <template v-for="addressType in ['beginningYear', 'endYear']">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                Adresse au {{ addressType === 'beginningYear' ? '1 janvier' : '31 décembre' }} de l'année déclarée {{ addressType === 'endYear' ? ' (en cas de changement d\'adresse au cours de l\'année)' : '' }}
                            </v-col>
                            <v-col cols="12" class="py-2 pr-1">
                                <v-text-field
                                    v-model="companyUser.investment[addressType + 'Address'].address"
                                    label="Adresse"
                                    class="oss-"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col v-for="field in fields" :cols="4" :class="field.class" :key="field.value">
                                <v-text-field
                                    v-if="field.value !== 'postalCode'"
                                    v-model="companyUser.investment[addressType + 'Address'][field.value]"
                                    :label="field.name"
                                    class="oss-"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                                <v-text-field
                                    v-else
                                    v-model="companyUser.investment[addressType + 'Address'][field.value]"
                                    label="Code Postal"
                                    class="oss-"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
</v-row> -->
                <v-divider />
                <v-row no-gutters class="pt-2 pb-2">
                    <v-col cols="12">
                        <h4>Parts</h4>
                    </v-col>
                    <!-- New version -->
                    <v-col cols="11" class="pt-2">
                        <v-data-table
                            :headers="companySharesHeaders"
                            :items="companyUser.investment.shares"
                            fixed-header
                            hide-default-footer
                            :no-data-text="'Pas d\'historique'"
                            :sort-by="sortByDateDesc"
                            style="border: 1px #ededed solid"
                            density="compact"
                            class="table elevation-0"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-center">{{ formatDate(props.item.date) }}</td>
                                    <td class="text-center">{{ props.item.quantity }}</td>
                                    <td class="text-center">
                                        {{ formatAmount(props.item.amount) }}
                                    </td>
                                    <td class="text-center">
                                        {{ formatPercentage(props.item.percentage) }}
                                    </td>
                                    <td class="text-center">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn-icon
                                                    icon="$oss-edit"
                                                    elevation="0"
                                                    rounded
                                                    dense
                                                    @click.stop="editShare(props.item)"
                                                    size="x-small"
                                                />
                                            </v-col>
                                        </v-row>
                                    </td>
                                    <td class="text-center">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn-trash
                                                    @click.stop="deleteItem(props.item, 'shares')"
                                                    size="x-small"
                                                />
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="1" class="pt-5 pl-2">
                        <v-tooltip location="start">
                            <template v-slot:activator="{ props }">
                                <v-btn-add-icon
                                    size="x-small"
                                    v-bind="props"
                                    @click="openSharesDialog()"
                                >
                                </v-btn-add-icon>
                            </template>
                            <span>Déclarer un changement</span>
                        </v-tooltip>
                    </v-col>
                    <!-- Old version -->
                    <!-- <template v-for="(section, index) in partsSections">
                        <v-col cols="11" :key="index">
                            <v-list>
                                <v-list-group :value="false" sub-group>
                                    <template v-slot:activator>

                                            <v-row>
                                                <v-col cols="9" class="d-flex align-center">
                                                    {{ section.title }}
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-chip outlined label>
                                                        {{ getSectionQuantity(section) }}
                                                    </v-chip>
                                                </v-col>
                                            </v-row>

                                        <template v-slot:append></template>
                                    </template>
                                    <v-list-item>
                                            <v-data-table dense :headers="getHistoryHeaders(section.header, section.value)
            " :items="companyUser.investment[section.items]" :no-data-text="'Pas d\'historique'" :sort-by="'date'"
                                                :sort-desc="true" style="border: 1px #ededed solid">

                                                <template v-slot:item="props">
                                                    <tr>
                                                        <td class="text-center">
                                                            {{ props.item[section.value] }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ formatDate(props.item.date) }}
                                                        </td>

                                                        <td class="text-center">
                                                            <v-row no-gutters>
                                                                <v-col cols="12"
                                                                    class="d-flex justify-center align-center">
                                                                    <v-btn elevation="0" rounded size=“x-small” dense icon
                                                                        @click.stop="true">
                                                                        <v-icon  size="small">$oss-edit</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </td>
                                                        <td class="text-center">
                                                            <v-row no-gutters>
                                                                <v-col cols="12"
                                                                    class="d-flex justify-center align-center">
                                                                    <v-btn elevation="0" rounded size=“x-small” dense icon
                                                                        @click.stop="true">
                                                                        <v-icon  size="small">$oss-trash</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-col>
                        <v-col cols="1" class="pt-5 pl-2">
                            <v-tooltip left>

                                <template v-slot:activator="{ on, props }">
                                    <v-btn
                                        fab
                                         size=“x-small”
                                        color="primary"
                                        @click="openDialog(section)"
                                        class="btn"

                                        elevation="0"
                                        v-on="on"
                                        v-bind="props"
                                    >
                                        <v-icon>$add</v-icon>
                                    </v-btn>
                                </template>
                                <span>Déclarer un changement</span>
                            </v-tooltip>
                        </v-col>
                    </template> -->
                </v-row>
                <v-divider />
                <v-row no-gutters class="pt-2 pb-2">
                    <v-col cols="12">
                        <h4>Titres</h4>
                    </v-col>
                    <!-- New Version -->
                    <v-col cols="11" class="pt-2">
                        <v-data-table
                            :headers="companyTitlesHeaders"
                            :items="companyUser.investment.titles"
                            fixed-header
                            hide-default-footer
                            :no-data-text="'Pas d\'historique'"
                            :sort-by="sortByDateDesc"
                            style="border: 1px #ededed solid"
                            density="compact"
                            class="table elevation-0"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-center">{{ formatDate(props.item.date) }}</td>
                                    <td class="text-center">
                                        {{ props.item.bareOwnershipShares }}
                                    </td>
                                    <td class="text-center">{{ props.item.usufructShares }}</td>
                                    <td class="text-center">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn-icon
                                                    icon="$oss-edit"
                                                    elevation="0"
                                                    rounded
                                                    dense
                                                    @click.stop="editTitle(props.item)"
                                                    size="x-small"
                                                />
                                            </v-col>
                                        </v-row>
                                    </td>
                                    <td class="text-center">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn-trash
                                                    @click.stop="deleteItem(props.item, 'titles')"
                                                    size="x-small"
                                                />
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="1" class="pt-5 pl-2">
                        <v-tooltip location="start">
                            <template v-slot:activator="{ props }">
                                <v-btn-add-icon
                                    size="x-small"
                                    @click="openTitlesDialog()"
                                    v-bind="props"
                                >
                                </v-btn-add-icon>
                            </template>
                            <span>Déclarer un changement</span>
                        </v-tooltip>
                    </v-col>
                    <v-row no-gutters class="d-flex align-center py-4">
                        <v-col cols="1" class="pr-3 d-flex justify-end">
                            <v-icon size="x-small">$fa-circle</v-icon>
                        </v-col>
                        <v-col cols="4" class="pl-3"> Détenteur de l'usufruit </v-col>
                        <v-col cols="6">
                            <v-text-field-filled
                                v-model="companyUser.investment.usufructHolder"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-row>
                <v-divider />
                <v-row no-gutters class="pt-2">
                    <v-col cols="12">
                        <h4>Jouissance de l'immeuble</h4>
                    </v-col>
                    <v-row no-gutters class="py-2">
                        <v-col cols="11">
                            Jouissance gratuite de tout ou partie d'un immeuble détenu par la
                            société immobilière
                        </v-col>
                        <v-col cols="1" class="pr-1 justify-end d-flex">
                            <v-checkbox
                                v-model="companyUser.investment.freeUse"
                                dense
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="py-2">
                        <v-col cols="8">
                            Immeuble(s) dont l'associé à la jouissance gratuite
                        </v-col>
                        <v-col cols="4" class="pr-1">
                            <v-select-filled
                                hide-details
                                outlined
                                multiple
                                v-model="companyUser.investment.freeUseBuildings"
                                :items="companyData.buildingsProperties"
                                item-value="name"
                                label="Immeubles"
                                density="compact"
                                :item-title="(item) => item.name"
                            />
                        </v-col>
                    </v-row>
                </v-row>
            </template>
            <oss-dialog
                v-model="sharesDialog"
                v-if="sharesDialog"
                title="Ajouter part(s)"
                @close="sharesDialog = false"
                @valid="upsertSharesTitles()"
                :valid-disabled="!isValidShares"
                width="800px"
            >
                <div>
                    <v-row no-gutters class="d-flex justify-center align-center pt-2">
                        <v-col cols="3">
                            <oss-date-picker-filled
                                label="Date"
                                v-model="newShare.date"
                                outlined
                                textFieldClass="oss- pb-5"
                                :disabled="isEditingShare"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="3">
                            <oss-text-field-filled
                                outlined
                                label="Parts détenues"
                                v-model="newShare.quantity"
                                class="pl-2 pt-1"
                                dense
                            >
                            </oss-text-field-filled>
                        </v-col>
                        <v-col cols="3">
                            <oss-text-field-filled
                                outlined
                                label="Montant nomial"
                                v-model="newShare.amount"
                                class="pl-2 pt-1"
                                dense
                            >
                            </oss-text-field-filled>
                        </v-col>
                        <v-col cols="3">
                            <oss-text-field-filled
                                outlined
                                label="Détenue en %"
                                v-model="newShare.percentage"
                                class="pl-2 pt-1"
                                dense
                            >
                            </oss-text-field-filled>
                        </v-col>
                    </v-row>
                </div>
            </oss-dialog>
            <oss-dialog
                v-model="titlesDialog"
                v-if="titlesDialog"
                title="Ajouter titre(s)"
                @close="titlesDialog = false"
                @valid="upsertSharesTitles()"
                :valid-disabled="!isValidTitles"
                width="800px"
            >
                <div>
                    <v-row no-gutters class="d-flex justify-center align-center pt-2">
                        <v-col cols="4">
                            <oss-date-picker-filled
                                label="Date"
                                v-model="newTitle.date"
                                outlined
                                textFieldClass="oss- pb-5"
                                hide-details
                                :disabled="isEditingTitle"
                            />
                        </v-col>
                        <v-col cols="4">
                            <oss-text-field-filled
                                outlined
                                label="Titres en nue-propriété"
                                v-model="newTitle.bareOwnershipShares"
                                class="pl-2 pt-1"
                                dense
                                @change="newTitle.usufructShares = 0"
                            >
                            </oss-text-field-filled>
                        </v-col>
                        <v-col cols="4">
                            <oss-text-field-filled
                                outlined
                                label="Titres en usufruit"
                                v-model="newTitle.usufructShares"
                                class="pl-2 pt-1"
                                dense
                                @change="newTitle.bareOwnershipShares = 0"
                            >
                            </oss-text-field-filled>
                        </v-col>
                    </v-row>
                </div>
            </oss-dialog>
        </div>
        <div v-else>
            <v-row no-gutters>
                <v-col cols="12" class="pb-1">
                    <!-- <h3>Investissement</h3> -->
                    <span class="title ml-2">Investissement</span>
                </v-col>
                <v-col cols="6">
                    <v-text-field-filled
                        v-model.number="companyUser.investment.capitalShare"
                        outlined
                        label="Nombre de parts"
                        hide-details
                        density="compact"
                        @change="autoFillAssociateSharePercentage"
                    />
                    <span>{{ associateSharesWarningMessage }}</span>
                </v-col>
                <v-col cols="6" class="pl-2">
                    <v-text-field-filled
                        v-model.number="companyUser.investment.amount"
                        outlined
                        label="Pourcentage"
                        hide-details
                        density="compact"
                        @change="autoFillAssociateSharesNumber"
                    />
                    <span>{{ associateSharePercentageWarningMessage }}</span>
                </v-col>
            </v-row>
        </div>

        <!-- À quoi sert ce code est dupliqué ?? Présent ligne 182 -->
        <!-- <v-divider></v-divider> -->
        <v-list-group
            v-if="companyUser.investment.partnerType !== 'shareTransfer' && legalForm === 'SCI'"
        >
            <template v-slot:activator>
                <v-list-item-title class="text-left text-wrap">
                    <b>Intégration dans la SCI (facultatif)</b>
                </v-list-item-title>
            </template>

            <v-row no-gutters class="py-2">
                <v-col cols="6" class="pr-1">
                    <oss-date-picker-filled
                        label="Date d'entrée"
                        v-model="companyUser.investment.entryDate"
                        outlined
                        :textFieldReadOnly="false"
                        :text-field-readonly="false"
                        hide-details="auto"
                    />
                </v-col>
                <v-col cols="6" class="pr-1">
                    <oss-date-picker-filled
                        v-model="companyUser.investment.exitDate"
                        :textFieldReadOnly="false"
                        :text-field-readonly="false"
                        hide-details="auto"
                    />
                </v-col>

                <template v-for="addressType in ['beginningYear', 'endYear']">
                    <v-row no-gutters class="pb-2">
                        <v-col cols="12">
                            Adresse au
                            {{ addressType === "beginningYear" ? "1 janvier" : "31 décembre" }}
                            de l'année déclarée
                            {{
                                addressType === "endYear"
                                    ? " (en cas de changement d'adresse au cours de l'année)"
                                    : ""
                            }}
                        </v-col>
                        <v-col cols="12" class="py-2 pr-1">
                            <v-text-field-filled
                                v-model="companyUser.investment[addressType + 'Address'].address"
                                label="Adresse"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col
                            v-for="field in fields"
                            :cols="4"
                            :class="field.class"
                            :key="field.value"
                        >
                            <v-text-field-filled
                                v-if="field.value !== 'postalCode'"
                                v-model="
                                    companyUser.investment[addressType + 'Address'][field.value]
                                "
                                :label="field.name"
                                outlined
                                hide-details
                                density="compact"
                            />
                            <v-text-field-filled
                                v-else
                                v-model="
                                    companyUser.investment[addressType + 'Address'][field.value]
                                "
                                label="Code Postal"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </template>
            </v-row>
        </v-list-group>
        <!-- <v-divider></v-divider> -->
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import gql from "graphql-tag";
import moment from "moment-timezone";
import _ from "lodash";

import COMPANY_USER from "../../graphql/user/CompanyUser.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {},
    emits: ["upserted"],
})
export class AssociateEdition extends Vue {
    @Model({ default: null }) user;
    @Prop({ default: null }) company;
    @Prop({ default: null }) actions: any;
    @Prop({ default: "" }) legalForm;
    @Prop({ default: false }) isUserWithAccount;

    upsertLoading: boolean = false;

    sharesDialog = false;
    titlesDialog = false;
    sharesDialogTitle = "";
    // formIsValid = false

    // fieldToModify = null
    // newItem = {
    //     date: moment().format()
    // }

    // selectedSection: any = {}

    newShare = {
        date: "",
        quantity: null,
        amount: null,
        percentage: null,
    };

    newTitle = {
        date: "",
        // quantity: null,
        bareOwnershipShares: null,
        usufructShares: null,
    };

    sortByDateDesc: { key: string; order: "asc" | "desc" | boolean }[] = [
        { key: "date", order: "desc" },
    ];

    // partnerType = "landTenureAssociate"

    defaultInvestment = {
        taxNumber: "",
        holding: false,
        siren: "",
        taxCategory: "",
        buildingNumber: "",
        accountant: {
            show: false,
            name: "",
            address: "",
            postalCode: "",
            city: "",
            country: "",
        },
        manager: {
            show: false,
            name: "",
            address: "",
            postalCode: "",
            city: "",
            country: "",
        },
        director: {
            show: false,
            name: "",
            address: "",
            postalCode: "",
            city: "",
            country: "",
        },
        entryDate: "",
        exitDate: "",
        beginningYearAddress: {
            address: "",
            postalCode: "",
            city: "",
            country: "",
        },
        endYearAddress: {
            address: "",
            postalCode: "",
            city: "",
            country: "",
        },
        shares: [],
        // sharesAmount: [],
        // sharesPercentage: [],
        titles: [],
        // bareOwnershipShares: [],
        // usufructShares: [],
        usufructHolder: "",
        freeUse: false,
        freeUseBuildings: [],
        partnerType: "landTenureAssociate",
    };

    defaultCompanyUser = {
        investment: JSON.parse(JSON.stringify(this.defaultInvestment)),
    };

    // partsSections = [
    //     {
    //         title: 'Nombre de parts détenues en pleine propriété dans la SCI',
    //         header: 'Nombre',
    //         value: 'quantity',
    //         items: 'shares',
    //     },
    //     {
    //         title: 'Montant nominal des parts',
    //         header: 'Montant',
    //         value: 'amount',
    //         items: 'sharesAmount',
    //     },
    //     {
    //         title: 'Pourcentage de détention',
    //         header: 'Pourcentage',
    //         value: 'percentage',
    //         items: 'sharesPercentage',
    //     }
    // ]

    titlesSections = [
        {
            title: "Nombre de titres détenus en nue-propriété",
            header: "Nombre",
            value: "quantity",
            items: "bareOwnershipShares",
        },
        {
            title: "Nombre de titres détenus en usufruit",
            header: "Nombre",
            value: "quantity",
            items: "usufructShares",
        },
    ];

    fields = [
        { value: "postalCode", name: "Code postal", class: "pr-1" },
        { value: "city", name: "Ville", class: "pr-1 pl-1" },
        { value: "country", name: "Pays", class: "pl-1" },
    ];

    roles = [
        { value: "director", name: "Administrateur" },
        { value: "accountant", name: "Comptable" },
        { value: "manager", name: "Gérant" },
    ];

    roleFields = [
        { value: "name", name: "Nom", class: "pr-1 py-2" },
        { value: "address", name: "Adresse", class: "pl-1 py-2" },
        { value: "postalCode", name: "Code postal", class: "pr-1" },
        { value: "city", name: "Ville", class: "pr-1 pl-1" },
        { value: "country", name: "Pays", class: "pl-1" },
    ];

    get type() {
        return this.user.type || "NATURAL_PERSON";
    }

    get userShares() {
        return this.companyUser.investment.shares || null;
    }

    get userTitles() {
        return this.companyUser.investment.titles || null;
    }

    // getHistoryHeaders(colName, colValue) {
    //     return [
    //         { text: colName, value: colValue, sortable: false, align: 'center' },
    //         { text: 'Date', value: 'date', sortable: true, align: 'center' },
    //         { text: 'Éditer', value: 'edit', sortable: false, align: 'center' },
    //         { text: 'Supprimer', value: 'delete', sortable: false, align: 'center' },
    //     ]
    // }

    get companySharesHeaders() {
        return [
            { title: "Date", value: "date", align: "center" },
            { title: "Parts détenues", value: "quantity", align: "center" },
            { title: "Montant nominal", value: "amount", align: "center" },
            { title: "Détention", value: "percentage", align: "center" },
            { title: "Éditer", value: "edit", align: "center" },
            { title: "Supprimer", value: "delete", align: "center" },
        ];
    }

    get companyTitlesHeaders() {
        return [
            { title: "Date", value: "date", align: "center" },
            { title: "Titres en nue-propriété", value: "bareOwnershipShares", align: "center" },
            { title: "Titres en usufruit", value: "usufructShares", align: "center" },
            { title: "Éditer", value: "edit", align: "center" },
            { title: "Supprimer", value: "delete", align: "center" },
        ];
    }

    get isValidShares() {
        if (
            this.newShare.quantity !== null &&
            this.newShare.amount !== null &&
            this.newShare.percentage !== null
        ) {
            return true;
        }
        return false;
    }

    get isValidTitles() {
        if (this.newTitle.bareOwnershipShares !== null || this.newTitle.usufructShares !== null) {
            return true;
        }
        return false;
    }

    get isEditingShare() {
        return (
            this.newShare.date !== "" &&
            this.companyUser.investment.shares.some((s) => s.date === this.newShare.date)
        );
    }

    get isEditingTitle() {
        return (
            this.newTitle.date !== "" &&
            this.companyUser.investment.titles.some((t) => t.date === this.newTitle.date)
        );
    }

    // getSectionQuantity(section) {
    //     let quantity = "0"
    //     if(this.companyUser.investment[section.items].length) {
    //         const last = this.companyUser.investment[section.items].length - 1
    //         quantity = this.companyUser.investment[section.items][last][section.value] + ""
    //     }
    //     if(section.value === "percentage") {
    //         quantity += " %"
    //     }
    //     else if(section.value === "amount") {
    //         quantity += " €"
    //     }
    //     return quantity.replace('.', ',')
    // }

    beforeMount() {
        if (this.actions) {
            // Aucun impact car @valid était déjà définit dans le composant oss-dialog ...
            // this.actions.action.title = "Valider"
            // this.actions.action.function = this.upsert
            // this.actions.action.disabled = this.associateInvalid
            // this.actions.action.loading = () => {return this.upsertLoading}
        }

        this.newShare = {
            date: "",
            quantity: null,
            amount: null,
            percentage: null,
        };

        this.newTitle = {
            date: "",
            bareOwnershipShares: null,
            usufructShares: null,
        };
    }

    @Apollo({
        query: gql`
            query CompanyBuildingsAndInvestments($id: ID!) {
                company(where: { id: $id }) {
                    buildings
                    shareTotal
                    companyUsers {
                        user {
                            id
                        }
                        investment
                    }
                }
            }
        `,
        variables() {
            return { id: this.company.id };
        },
        skip() {
            return !this.company.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.company) {
                    const sharesNumber: number = data.company?.shareTotal ?? 0;
                    const othersAssociatesShares: number = this.getOthersAssociatesShares(
                        data.company.companyUsers,
                    );
                    this.companyData = {
                        buildingsProperties: data.company.buildings?.properties || [],
                        sharesNumber,
                        othersAssociatesShares,
                        availableShares: sharesNumber - othersAssociatesShares,
                    };
                }
            }
        },
    })
    companyData: {
        buildingsProperties: [];
        sharesNumber: number;
        othersAssociatesShares?: number;
        availableShares?: number;
    } = { buildingsProperties: [], sharesNumber: 0 };

    @Apollo({
        query: COMPANY_USER,
        variables() {
            return {
                companyId: this.company.id,
                userId: this.user.id,
            };
        },
        skip() {
            return !this.company?.id || !this.user?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.companyUserFirst) {
                    const companyUser = data.companyUserFirst;
                    if (!companyUser.investment) {
                        if (this.legalForm === "SCI") {
                            companyUser.investment = _.cloneDeep(this.defaultInvestment);
                        } else {
                            companyUser.investment = {
                                capitalShare: 0,
                                amount: 0,
                            };
                        }
                    } else if (this.legalForm === "SCI") {
                        delete companyUser.investment.capitalShare;
                        delete companyUser.investment.amount;
                        for (const attribute in this.defaultInvestment) {
                            if (["director", "manager", "accountant"].includes(attribute)) {
                                if (!companyUser.investment?.[attribute]?.show) {
                                    companyUser.investment[attribute] = {
                                        show: false,
                                        name: "",
                                        address: "",
                                        postalCode: "",
                                        city: "",
                                        country: "",
                                    };
                                }
                            } else if (
                                ["endYearAddress", "beginningYearAddress"].includes(attribute)
                            ) {
                                if (!companyUser.investment?.[attribute]) {
                                    companyUser.investment[attribute] = {
                                        address: "",
                                        postalCode: "",
                                        city: "",
                                        country: "",
                                    };
                                } else {
                                    for (const att2 in [
                                        "adress",
                                        "postalCode",
                                        "city",
                                        "country",
                                    ]) {
                                        if (!companyUser.investment?.[attribute][att2]) {
                                            companyUser.investment[attribute][att2] = "";
                                        }
                                    }
                                }
                            } else if (attribute.match(/(shares)|(buildings)/gi)) {
                                if (!companyUser.investment?.[attribute]?.length) {
                                    companyUser.investment[attribute] = [];
                                }
                            } else if (attribute.match(/(titles)|(buildings)/gi)) {
                                if (!companyUser.investment?.[attribute]?.length) {
                                    companyUser.investment[attribute] = [];
                                }
                            } else if (!companyUser.investment?.[attribute]) {
                                companyUser.investment[attribute] = "";
                            }
                            if (companyUser.investment.taxCategory) {
                                this.partnerType = "professionalRegimeAssociate";
                            } else if (companyUser.investment.buildingNumber) {
                                this.partnerType = "shareTransfer";
                            } else {
                                this.partnerType = "landTenureAssociate";
                            }
                        }
                    }
                    this.companyUser = companyUser;
                } else {
                    this.companyUser = _.cloneDeep(this.defaultCompanyUser);
                }
            }
        },
    })
    companyUser = _.cloneDeep(this.defaultCompanyUser);

    openSharesDialog() {
        this.sharesDialog = true;
    }

    openTitlesDialog() {
        this.titlesDialog = true;
    }

    async upsertSharesTitles() {
        if (
            this.newShare &&
            this.newShare.quantity !== null &&
            this.newShare.amount !== null &&
            this.newShare.percentage !== null
        ) {
            const indexShares = this.companyUser.investment.shares.findIndex(
                (s) => s.date === this.newShare.date,
            );

            // Ces conditions gèrent l'ajout / édition d'une part
            if (indexShares === -1) {
                this.companyUser.investment.shares.push({ ...this.newShare });
            } else {
                this.companyUser.investment.shares[indexShares] = { ...this.newShare };
            }
        }

        if (
            this.newTitle &&
            this.newTitle.bareOwnershipShares !== null &&
            this.newTitle.usufructShares !== null
        ) {
            const indexTitles = this.companyUser.investment.titles.findIndex(
                (t) => t.date === this.newTitle.date,
            );

            // Ces conditions gèrent l'ajout / édition d'un titre
            if (indexTitles === -1) {
                this.companyUser.investment.titles.push({ ...this.newTitle });
            } else {
                this.companyUser.investment.titles[indexTitles] = { ...this.newTitle };
            }
        }

        const upserted = await this.upsert();

        if (upserted.success) {
            this.newShare = {
                date: "",
                quantity: null,
                amount: null,
                percentage: null,
            };
            this.newTitle = {
                date: "",
                bareOwnershipShares: null,
                usufructShares: null,
            };
        }

        this.titlesDialog = false;
        this.sharesDialog = false;
    }

    async upsert() {
        this.upsertLoading = true;
        if (
            this.companyUser.investment.partnerType === "landTenureAssociate" &&
            this.user.type === "NATURAL_PERSON"
        ) {
            this.companyUser.investment.holding = false;
            for (const attribute of [
                "siren",
                "taxCategory",
                "buildingNumber",
                "holding",
                "manager",
                "accountant",
                "director",
            ]) {
                this.companyUser.investment[attribute] = _.cloneDeep(
                    this.defaultInvestment[attribute],
                );
            }
        } else if (this.user.type === "NATURAL_PERSON") {
            if (this.companyUser.investment.partnerType === "professionalRegimeAssociate") {
                this.companyUser.investment.taxNumber = "";
                this.companyUser.investment.buildingNumber = "";
            } else if (this.companyUser.investment.partnerType === "landTenureAssociate") {
                for (const attribute of [
                    "taxNumber",
                    "taxCategory",
                    "buildingNumber",
                    "holding",
                    "manager",
                    "accountant",
                    "director",
                ]) {
                    this.companyUser.investment[attribute] = _.cloneDeep(
                        this.defaultInvestment[attribute],
                    );
                }
            }
        } else if (this.companyUser.investment.partnerType === "shareTransfer") {
            const attributes = Object.keys(this.defaultInvestment).filter(
                (k) => !["siren", "buildingNumber"].includes(k),
            );
            for (const attribute of attributes) {
                this.companyUser.investment[attribute] = _.cloneDeep(
                    this.defaultInvestment[attribute],
                );
            }
        }
        // debugger
        const result = await this.$apollo.mutate({
            mutation: gql`
                mutation UpsertCompanyUser(
                    $id: ID!
                    $companyId: ID!
                    $userId: ID!
                    $investment: Json
                ) {
                    upsertCompanyUser(
                        where: { id: $id }
                        create: {
                            company: { connect: { id: $companyId } }
                            user: { connect: { id: $userId } }
                            investment: $investment
                        }
                        update: {
                            company: { connect: { id: $companyId } }
                            user: { connect: { id: $userId } }
                            investment: $investment
                        }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                id: (this.companyUser as any).id || "",
                companyId: this.company.id,
                userId: this.user.id,
                investment: this.companyUser.investment,
            },
        });
        if (result?.data?.upsertCompanyUser?.id) {
            (this.companyUser as any).id = result.data.upsertCompanyUser.id;
            this.upsertLoading = false;
            this.$emit("upserted");

            return {
                success: true,
            };
        } else {
            debugger; // git-ignore
            return {
                success: false,
            };
        }
    }

    get selectedCompany() {
        return this.$store.state.selected_company || { id: "" };
    }

    async deleteItem(item, type) {
        const index = this.companyUser.investment[type].indexOf(item);
        // -1 si l'élément n'est pas trouvé
        if (index > -1) {
            this.companyUser.investment[type].splice(index, 1);
            await this.upsert();
        }
    }

    editShare(share) {
        this.newShare = share;
        this.sharesDialog = true;
    }

    editTitle(title) {
        this.newTitle = title;
        this.titlesDialog = true;
    }

    @Watch("user.type")
    onUserTypeChange() {
        if (
            this.companyUser.investment.partnerType !== "landTenureAssociate" &&
            this.user.type === "NATURAL_PERSON"
        ) {
            this.companyUser.investment.partnerType = "landTenureAssociate";
        }
    }

    @Watch("companyUser.investment.partnerType")
    onPartnerTypeChange() {
        if (this.companyUser.investment.partnerType === "landTenureAssociate") {
            if (!this.companyUser.investment.taxCategory) {
                this.companyUser.investment.taxCategory = null;
            }

            this.companyUser.investment.holding = false;
            this.companyUser.investment.director.show = false;
            this.companyUser.investment.manager.show = false;
            this.companyUser.investment.accountant.show = false;
        }
    }

    formatDate(date) {
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
        return "-";
    }

    formatAmount(amount) {
        if (amount) {
            return amount + " €";
        }
        return "-";
    }

    formatPercentage(percentage) {
        if (percentage) {
            return percentage + " %";
        }
        return "-";
    }

    /**
     * To get the number of company shares held by others associates
     * @param companyUsersData
     */
    getOthersAssociatesShares(
        companyUsersData: { investment?: { capitalShare: number }; user?: { id: string } }[],
    ): number {
        const usersInvestments = companyUsersData.filter((cu) => {
            return cu.investment && cu.user && cu.user?.id !== this.user.id;
        });

        const othersUsersShares = usersInvestments.reduce(
            (acc, val) => acc + (val?.investment?.capitalShare ?? 0),
            0,
        );

        return othersUsersShares;
    }

    /**
     * To display message in case of incoherent value
     */
    associateSharesWarningMessage = "";

    /**
     * Automatically fills the 'Pourcentage' input
     * calculating the associate's percentage share of the company,
     * according to his number of shares, and the number of shares available in the company.
     */
    autoFillAssociateSharePercentage() {
        if (this.companyData.sharesNumber > 0) {
            const associateShares = this.companyUser.investment.capitalShare;
            if (associateShares == null || associateShares == "" || isNaN(associateShares)) {
                this.associateSharesWarningMessage = "";
                this.associateSharePercentageWarningMessage = "";
            } else if (associateShares < 0 || associateShares > this.companyData.availableShares) {
                this.associateSharesWarningMessage =
                    "Attention, vous avez indiqué un nombre de parts non compris " +
                    "entre 0 et le nombre de parts disponible " +
                    "(" +
                    this.companyData.availableShares +
                    ")";
            } else {
                const percentage = (associateShares / this.companyData.sharesNumber) * 100;
                this.companyUser.investment.amount = Number(percentage.toFixed(2));
                this.associateSharesWarningMessage = "";
                this.associateSharePercentageWarningMessage = "";
            }
        }
    }

    /**
     * To display message in case of incoherent value
     */
    associateSharePercentageWarningMessage = "";

    /**
     * Automatically fills the 'Nombre de part' input
     * calculating the number of shares held by the associate,
     * according to his percentage and the number of shares available in the company.
     */
    autoFillAssociateSharesNumber() {
        if (this.companyData.sharesNumber > 0) {
            const othersAssociatesSharesRatio =
                this.companyData.othersAssociatesShares / this.companyData.sharesNumber;
            const availableSharePercentage = (1 - othersAssociatesSharesRatio) * 100;
            const associateSharePercentage = this.companyUser.investment.amount;
            if (
                associateSharePercentage == null ||
                associateSharePercentage == "" ||
                isNaN(associateSharePercentage)
            ) {
                this.associateSharesWarningMessage = "";
                this.associateSharePercentageWarningMessage = "";
            } else if (
                associateSharePercentage < 0 ||
                associateSharePercentage > availableSharePercentage
            ) {
                this.associateSharePercentageWarningMessage =
                    "Attention, vous avez indiqué un pourcentage non compris " +
                    "entre 0 et le pourcentage de parts disponible " +
                    "(" +
                    availableSharePercentage +
                    ")";
            } else {
                const shareNumber =
                    (associateSharePercentage / 100) * this.companyData.sharesNumber;
                this.companyUser.investment.capitalShare = Number(shareNumber.toFixed(2));
                this.associateSharesWarningMessage = "";
                this.associateSharePercentageWarningMessage = "";
            }
        }
    }

    // calculateTotalShares(): number {
    //     let total: number = 0;

    //     if (this.companyUser.investment.shares && this.companyUser.investment.shares.length > 0) {
    //         this.companyUser.investment.shares.forEach(item => {
    //             if (item.quantity !== undefined && item.quantity > 0) {
    //                 total += item.quantity;
    //             }
    //         });
    //     }

    //     return total;
    // }

    // calculateTotalShareAmount(): number {
    //     let totalShareAmount: number = 0;
    //     if (this.companyUser.investment.sharesAmount && this.companyUser.investment.sharesAmount.length > 0) {
    //         this.companyUser.investment.sharesAmount.forEach(share => {
    //             if (share.amount !== undefined && share.amount > 0) {
    //                 totalShareAmount += share.amount;
    //             }

    //         });
    //     }
    //     return totalShareAmount;
    // }

    // calculateTotalbareOwnershipShares(): number {
    //     let TotalbareOwnershipShares: number = 0;
    //     if (this.companyUser.investment.bareOwnershipShares && this.companyUser.investment.bareOwnershipShares.length > 0) {

    //         this.companyUser.investment.bareOwnershipShares.forEach(bareOwnershipShares => {
    //             if (bareOwnershipShares.quantity !== undefined) {
    //                 TotalbareOwnershipShares += bareOwnershipShares.quantity;
    //             } console.log(this.companyUser.investment);

    //         });
    //     }
    //     return TotalbareOwnershipShares;
    // }

    // calculateTotalusufructShares(): number {
    //     let TotalusufructShares: number = 0;

    //     if (this.companyUser.investment.usufructShares && this.companyUser.investment.usufructShares.length > 0) {
    //         this.companyUser.investment.usufructShares.forEach(usufructShares => {
    //             if (usufructShares.quantity !== undefined) {
    //                 TotalusufructShares += usufructShares.quantity;
    //             }
    //         });
    //     }

    //     return TotalusufructShares;
    // }

    // calculateTotalpercentage(): number {
    //     let Totalpercentage: number = 0;

    //     if (this.companyUser.investment.sharesPercentage && this.companyUser.investment.sharesPercentage.length > 0) {
    //         this.companyUser.investment.sharesPercentage.forEach(sharesPercentage => {
    //             if (sharesPercentage.percentage !== undefined) {
    //                 Totalpercentage += sharesPercentage.percentage;
    //             }
    //         });
    //     }

    //     return Totalpercentage;
    // }

    // get shareCapital() {
    //     return this.company.shareCapital;
    // }

    // calculateTotalInvest(): number | string | undefined {
    //     let totalShares = this.calculateTotalShares();
    //     let totalPrice = this.calculateTotalShareAmount();

    //     let percentage = totalShares * totalPrice;
    //     let result = parseFloat(percentage.toFixed(2));

    //     if (result > this.shareCapital) {
    //         return `Vous ne pouvez pas investir plus que le capital social de : ${this.shareCapital}`;
    //     }

    //     return result;
    // }
}

export default toNative(AssociateEdition);
</script>

<style lang="scss">
.v-list-group__header:hover {
    background-color: transparent !important;
}
</style>
